module.exports = __webpack_public_path__ + "static/mainLogo-f6e178046a7197f67a55ddd0b853c504.png";